export default __webpack_public_path__ + "static/media/jacket.fd8a568d.jpg";